import React, { Component } from 'react';
import { Breadcrumb } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

class Breadcrumbs extends Component {
  render() {
    const { crumbs } = this.props;
    // If crumbs is empty or not passed, output nothing
    if (crumbs === undefined || crumbs.length === 0) {
      return null;
    }
    var renderBreadcrumbs = () => {
      return crumbs.map((crumb, index) => {
        if(crumb.active) {
          return (
            <Breadcrumb.Item key={index} active>
              {crumb.text}
            </Breadcrumb.Item>
          );
        } else {
         return (
           <LinkContainer to={crumb.url} key={index}>
             <Breadcrumb.Item>
               {crumb.text}
             </Breadcrumb.Item>
           </LinkContainer>
         );
        }
      });
    };

    return(
      <Breadcrumb>
        {renderBreadcrumbs()}
      </Breadcrumb>
    );
  }
}

export default Breadcrumbs;